import { createAction } from 'redux-act';

export interface IPortfoliosOverviewSortPayload {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

export const setPortfoliosOverviewPage = createAction<number>('SET_PORTFOLIOS_OVERVIEW_PAGE');
export const setPortfoliosOverviewSearch = createAction<string>('SET_PORTFOLIOS_OVERVIEW_SEARCH');
export const setPortfoliosOverviewSort = createAction<IPortfoliosOverviewSortPayload>(
  'SET_PORTFOLIOS_OVERVIEW_SORT'
);
export const resetPortfoliosOverviewUi = createAction('RESET_PORTFOLIOS_OVERVIEW_UI');
